import { serverApi } from "./serverApi";
import { ErrorType } from "../types/sharedTypes";
import { TestCaseIncoming } from "../types/testCaseIncomingTypes";

export const testCaseIncomingService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllTestCaseIncoming: build.query<Array<TestCaseIncoming>, string>({
      query: () => ({
        url: "/test-case-incoming/all-incomings"
      })
    }),
    createTestCaseIncoming: build.mutation<number, TestCaseIncoming>({
      query: (testCaseTemplate) => ({
        url: "/test-case-incoming/incoming",
        method: "POST",
        body: testCaseTemplate
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    }),
    updateTestCaseIncoming: build.mutation<string, TestCaseIncoming>({
      query: (testCaseTemplate) => ({
        url: "/test-case-incoming/incoming",
        method: "PUT",
        body: testCaseTemplate
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    }),
    deleteTestCaseIncoming: build.mutation<string, number>({
      query: (testCaseTemplateId) => ({
        url: "/test-case-incoming/incoming",
        method: "DELETE",
        params: { id: testCaseTemplateId }
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    })
  })
});

export const {
  useGetAllTestCaseIncomingQuery,
  useCreateTestCaseIncomingMutation,
  useUpdateTestCaseIncomingMutation,
  useDeleteTestCaseIncomingMutation
} = testCaseIncomingService;